import { createRouter, createWebHashHistory } from 'vue-router'
import Informations from '../views/Informations.vue'
import WeChatMini from '../views/weChatMini/index.vue'
import Login from '../views/weChatMini/login.vue'
import LoginPhone from '../views/weChatMini/loginPhone.vue'
import CourseSelection from '../views/course-selection/index.vue'
import ScoreSubmission from '../views/score-submission/index.vue'

import WeeklyRecipe from '../views/WeeklyRecipe.vue'
import BusinessReports from '../views/BusinessReports.vue'
import EditStudentsInfo from '../views/weChatMini/editStudentsInfo.vue'

import CollegeStudents from '../views/weChatMini/collegeStudents.vue'
import StudentsInfo from '../views/weChatMini/studentsInfo.vue'
import SignIn from '../views/weChatMini/signIn.vue'
import TravelRecords from '../views/weChatMini/travelRecords.vue'
import MealRecord from '../views/weChatMini/mealRecord.vue'
import SignInRecord from '../views/weChatMini/signInRecord.vue'
import MonitorStudents from '../views/weChatMini/monitorStudents.vue'
import ManagementPanel from '../views/weChatMini/managementPanel.vue'

import ActivityGraphic from '../views/activity/graphic.vue'
import ActivityEat from '../views/activity/eat.vue'
import ActivitySleep from '../views/activity/sleep.vue'
import ActivityStudent from '../views/activity/student.vue'
import ActivityChuang from '../views/activity/chuang.vue'



import PointsExchange from '../views/points/exchange.vue'
import PointsDetails from '../views/points/details.vue'

import RegistrationChannel from '../views/registration/channel.vue'

import TeacherPage from '../views/gaobu/teacher.vue'
import ClassDetail from '../views/gaobu/class.vue'
import Monitor from '../views/gaobu/monitor.vue'
import Lesson from '../views/gaobu/lesson.vue'
import FiftyThree from '../views/gaobu/fiftyThree.vue'
import MonitorDetail from '../views/gaobu/monitorDetail.vue'
import VideoGroup from '../views/gaobu/video.vue'
import Schedule from '../views/gaobu/Schedule/Schedule.vue'

import Registration from '../views/registration/index.vue'
import HtmlParsing from '../views/registration/htmlParsing.vue'

import TeacherLesson from '../views/gaobu/teacher-lesson.vue'
import WeekSchedule from '../views/gaobu/weekSchedule.vue'
import ClassList from '../views/gaobu/classList.vue'
import ClassDetailNew from '../views/gaobu/classDetail.vue'
import StudentList from '../views/gaobu/studentList.vue'
import TeacherList from '../views/gaobu/teacherList.vue'
import Statistics from '../views/Statistics.vue'
import CourseStatistics from '../views/oa/courseStatistics.vue'
import HoursDetail from '../views/oa/HoursDetail.vue'
import TeacherDetail from '../views/oa/TeacherDetail.vue'
import RevenueStatistics from '../views/oa/RevenueStatistics.vue'
import RevenueStatisticsNew from '../views/oa/RevenueStatisticsNew.vue'
import ClassStudentStatistics from '../views/oa/ClassStudentStatistics.vue'
import CoordinationRecords from '../views/oa/CoordinationRecords.vue'
const routes = [
  {
    path: '/informations',
    component: Informations,
    name: 'Informations',
    meta: { title: '资讯' }
  },
  {
    path: '/weeklyRecipe',
    component: WeeklyRecipe,
    name: 'WeeklyRecipe',
    meta: { title: '每周食谱' }
  },
  {
    path: '/userAgreement',
    component: () => import(/* webpackChunkName: "userAgreement" */ '../views/UserAgreement.vue'),
    name: 'UserAgreement',
    meta: { title: '用户协议' }
  },
  {
    path: '/privacyAgreement',
    component: () => import(/* webpackChunkName: "privacyAgreement" */ '../views/PrivacyAgreement.vue'),
    name: 'PrivacyAgreement',
    meta: { title: '用户协议' }
  },
  {
    path: '/businessReports',
    component: BusinessReports,
    name: 'BusinessReports',
    meta: { title: '营养报告' }
  },
  {
    path: '/weChatMini',
    component: WeChatMini,
    name: 'WeChatMini',
    meta: { title: '优益优宝' }
  },
  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta: { title: '优益优宝登录' }
  },
  {
    path: '/loginPhone',
    component: LoginPhone,
    name: 'LoginPhone',
    meta: { title: '优益优宝登录' }
  },
  {
    path: '/collegeStudents',
    component: CollegeStudents,
    name: 'CollegeStudents',
    meta: { title: '学校学生' }
  },
  {
    path: '/studentsInfo',
    component: StudentsInfo,
    name: 'StudentsInfo',
    meta: { title: '学生详情' }
  },
  {
    path: '/editStudentsInfo',
    component: EditStudentsInfo,
    name: 'EditStudentsInfo',
    meta: { title: '学生详情' }
  },
  
  {
    path: '/signIn',
    component: SignIn,
    name: 'SignIn',
    meta: { title: '签到统计' }
  },
  {
    path: '/travelRecords',
    component: TravelRecords,
    name: 'TravelRecords',
    meta: { title: '进房情况' }
  },
  {
    path: '/mealRecord',
    component: MealRecord,
    name: 'MealRecord',
    meta: { title: '餐食记录' }
  },
  {
    path: '/signInRecord',
    component: SignInRecord,
    name: 'SignInRecord',
    meta: { title: '签到记录' }
    
  },
  {
    path: '/monitorStudents',
    component: MonitorStudents,
    name: 'MonitorStudents',
    meta: { title: '监控' }
    
  },
  {
    path: '/activity/graphic',
    component: ActivityGraphic,
    name: 'ActivityGraphic',
    meta: { title: '活动详情' }
  },
  {
    path: '/activity/eat',
    component: ActivityEat,
    name: 'ActivityEat',
    meta: { title: '吃' }
  },
  {
    path: '/activity/student',
    component: ActivityStudent,
    name: 'ActivityStudent',
    meta: { title: '学' }
  },
  {
    path: '/activity/sleep',
    component: ActivitySleep,
    name: 'ActivitySleep',
    meta: { title: '睡' }
  },
  {
    path: '/activity/chuang',
    component: ActivityChuang,
    name: 'ActivityChuang',
    meta: { title: '创' }
  },
  {
    path: '/points/exchange',
    component: PointsExchange,
    name: 'PointsExchange',
    meta: { title: '积分' }
  },
  {
    path: '/points/detail',
    component: PointsDetails,
    name: 'PointsDetails',
    meta: { title: '积分明细' }
  },
  {
    path: '/managementPanel',
    component: ManagementPanel,
    name: 'ManagementPanel',
    meta: { title: '经营看板' }
  },
  {
    path: '/registrationChannel',
    component: RegistrationChannel,
    name: 'RegistrationChannel',
    meta: { title: '优益优高考补习学校报名通道' }
  },
  {
    path: '/teacherPage',
    component: TeacherPage,
    name: 'TeacherPage',
    meta: { title: '名师风采' }
    
  },
  {
    path: '/teacherDetail',
    component: TeacherDetail,
    name: 'TeacherDetail',
    meta: { title: '老师详情' }
  },
  {
    path: '/classDetail',
    component: ClassDetail,
    name: 'ClassDetail',
    meta: { title: '班级详情' }
  },
  {
    path: '/monitor',
    component: Monitor,
    name: 'Monitor',
    meta: { title: '监控' }
  },
  {
    path: '/monitorDetail',
    component: MonitorDetail,
    name: 'MonitorDetail',
    meta: { title: '监控详情' }
  },
  {
    path: '/lesson',
    component: Lesson,
    name: 'Lesson',
    meta: { title: '班级课表' }
  },
  {
    path: '/9853',
    component: FiftyThree,
    name: 'FiftyThree',
    meta: { title: '9853管理体系' }
  },
  {
    path: '/videogroup',
    component: VideoGroup,
    name: 'VideoGroup',
    meta: { title: '授课视频' }
  },
  {
    path: '/schedule',
    component: Schedule,
    name: 'Schedule',
    meta: { title: '课表' }
  },
  {
    path: '/registration',
    component: Registration,
    name: 'registration',
    meta: { title: '问卷调查' }
  },
  {
    path: '/htmlParsing',
    component: HtmlParsing,
    name: 'htmlParsing',
    meta: { title: '问卷调查' }
    
  },
  {
    path: '/course-selection',
    component: CourseSelection,
    name: 'CourseSelection',
    meta: { title: '课程选择' }
  },
  {
    path: '/score-submission',
    component: ScoreSubmission,
    name: 'ScoreSubmission',
    meta: { title: '成绩提交' }
  },
  {
    path: '/teacherLesson',
    component: TeacherLesson,
    name: 'TeacherLesson',
    meta: { title: '老师课表' }
  },
  {
    path: '/weekSchedule',
    component: WeekSchedule,
    name: 'WeekSchedule',
    meta: { title: '周课表' }
  },
  {
    path: '/classList',
    component: ClassList,
    name: 'ClassList',
    meta: { title: '班级列表' }
  },
  {
    path: '/classDetailNew',
    component: ClassDetailNew,
    name: 'ClassDetailNew',
    meta: { title: '班级详情' }
  },
  {
    path: '/studentList',
    component: StudentList,
    name: 'StudentList',
    meta: { title: '学生列表' }
  },
  {
    path: '/teacherList',
    component: TeacherList,
    name: 'TeacherList',
    meta: { title: '老师列表' }
  }, 
  {
    path: '/statistics',
    component: Statistics,
    name: 'Statistics',
    meta: { title: '课时统计' }
    
  },
  {
    path: '/courseStatistics',
    component: CourseStatistics,
    name: 'CourseStatistics',
    meta: { title: '课程统计' }
  },
  {
    path: '/hoursDetail',
    component: HoursDetail,
    name: 'HoursDetail',
    meta: { title: '课时详情' }
  },
  {
    path: '/teacherDetail',
    component: TeacherDetail,
    name: 'TeacherDetail',
    meta: { title: '老师详情' }
  },
  {
    path: '/revenueStatistics',
    component: RevenueStatistics,
    name: 'RevenueStatistics',
    meta: { title: '营收统计' }
  },
  {
    path: '/revenueStatisticsNew',
    component: RevenueStatisticsNew,
    name: 'RevenueStatisticsNew',
    meta: { title: '营收统计' }
  },
  {
    path: '/classStudentStatistics',
    component: ClassStudentStatistics,
    name: 'ClassStudentStatistics',
    meta: { title: '班课人数统计' }
  },
  {
    path: '/coordinationRecords',
    component: CoordinationRecords,
    name: 'CoordinationRecords',
    meta: { title: '协调记录' }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
